import React, { ReactNode } from 'react';

import { RemoveVehicleContainer } from './styled';

interface RemoveVehicleProps {
  children: ReactNode;
  onOpen?: () => void;
}

const RemoveVehicle = ({ children, onOpen }: RemoveVehicleProps) => (
  <RemoveVehicleContainer
    data-testid="remove-vehicle-container"
    role="button"
    tabIndex={0}
    onClick={onOpen}
    onKeyDown={(e: React.KeyboardEvent) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        onOpen?.();
      }
    }}
  >
    {children}
  </RemoveVehicleContainer>
);

export default RemoveVehicle;